/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import { getgeneralsystemparameterDetails } from '../../Modules/System/systemParameter/store/actions';
import { getUserDefaults } from '../../Modules/System/UserDefault/store/actions';
import SaveCancelPopup from '../CustomSaveCancelPopup/SaveCancelPopup';
import { USER_DEFAULT_INFO } from '../AppConstants';
import { dispatchIsUserDefaultMsgSet } from './store/action';
import { redirectURLLink } from '../CommonUtilities/commonUtilities';

function DashboardSearch() {
  const dispatch = useDispatch();
  const history = useHistory();

  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  useEffect(() => {
    if (logInUser) {
      dispatch(getgeneralsystemparameterDetails());
    }
  }, []);
  React.useEffect(() => {
    if (logInUser) dispatch(getUserDefaults(logInUser));
  }, [logInUser]);
  const [open, setOpen] = useState(false);
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues
  );
  const isUserDefaultSet = useSelector(
    (state) => state.sharedState.DashboardReducer.isUserDefaultSet
  );

  useEffect(() => {
    if (!isUserDefaultSet) {
      return;
    }
    if (
      UserDefaultValues?.message &&
      UserDefaultValues?.status === '004' &&
      UserDefaultValues?.message === USER_DEFAULT_INFO
    ) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [UserDefaultValues]);

  return (
    <>
      <div className="tabs-container">
        <SaveCancelPopup
          open={open}
          title="Default Setting"
          isInfo
          onConfim={() => {
            redirectURLLink('/userDefault', 'User Default', history, dispatch);
            dispatch(dispatchIsUserDefaultMsgSet(false));
            setOpen(false);
          }}
          onCancel={() => {
            redirectURLLink('/userDefault', 'User Default', history, dispatch);
            dispatch(dispatchIsUserDefaultMsgSet(false));
            setOpen(false);
          }}
          content={UserDefaultValues?.message}
        />
        <div className="container-fluid h-100 d-flex flex-column justify-content-between py-3">
          <div className="row banner-section" id="banner-section">
            <div className="image-responsive">
              <img
                src="/images/state_banner.jpg"
                alt="Welcome to CMdS-Rebates"
              />
            </div>
            <div className="banner-text">
              <div className="large-text">Welcome to CMdS-Rebates</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default withRouter(DashboardSearch);
